define("shared/utils/string-formatters/remove-underscores", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   */
  /**
   * @class removeUnderscores
   * @extends Utils
   */
  /** Returns a version of the given string with underscores removed
   *
   * @method removeUnderscores
   * @param {String} str string with underscores
   *
   * @returns {String} string without underscores
   * @protected
   */
  var _default = str => str.replace(/_/g, '');
  _exports.default = _default;
});